import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import type { Lang } from '../types';

interface LangCtx { lang: Lang; setLang: (l: Lang) => void; t: (ro: string, en: string) => string; }
const LangContext = createContext<LangCtx>({ lang: 'ro', setLang: () => {}, t: (ro) => ro });

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => (localStorage.getItem('cms_lang') as Lang) || 'ro');
  const setLang = (l: Lang) => { setLangState(l); localStorage.setItem('cms_lang', l); };
  const t = (ro: string, en: string) => lang === 'ro' ? ro : en;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
